import React from "react";
import { useParams } from "react-router-dom";

export default function Playvideo() {
  const { mediaType, mediaId } = useParams();

  // Check if mediaId and mediaType are available
  if (!mediaId || !mediaType) {
    return <div>Error: Media ID or Media Type not provided</div>;
  }

  const generateVideoLink = (type, id) => {
    if (type === "movie") {
      return `https://vidsrc.mov/embed/movie/${id}`;
    } else if (type === "tv") {
      return `https://vidsrc.mov/embed/tv/${id}`;
    } else {
      return ''; 
    }
  };

  const videoLink = generateVideoLink(mediaType, mediaId);

  return (
    <>
      {/* <embed  className="w-full h-screen" src={videoLink} type="" /> */}
      <iframe allowFullScreen className="w-full h-screen" src={videoLink} frameborder="0"></iframe>
    </>
  );
}
